import { render, staticRenderFns } from "./FireStatistics.vue?vue&type=template&id=4d5865d8&scoped=true&"
import script from "./FireStatistics.vue?vue&type=script&lang=js&"
export * from "./FireStatistics.vue?vue&type=script&lang=js&"
import style0 from "./FireStatistics.vue?vue&type=style&index=0&id=4d5865d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5865d8",
  null
  
)

export default component.exports